import api from "../Interceptors/Interceptor";
import { BaseService } from "./BaseService";
import { AxiosResponse } from "axios";
import ApiResponse from "../Models/ApiResponse";

export interface HomeMessageModel {
    uuid: string
    title: string
    message: string
    path: string
    read: boolean
    includeRead: boolean
    messageUser: {
        uuid: string,
        name: string
    }
}

export class HomeMessageService extends BaseService<HomeMessageModel, HomeMessageModel> {

    protected modelUrl(): string {
        return "notification";
    }

    public async fetchItemNotifications(params?: any): Promise<AxiosResponse> {
        return await api.get(`v1/${this.modelUrl()}`, {
            params: params
        });
    }

    public async fetchreadComments(): Promise<AxiosResponse> {
        return await api.get(`v1/${this.modelUrl()}/read-notifications`, {});
    }

    public async fetchUnreadComments(uuid: string): Promise<AxiosResponse<number>> {
        return await api.get(`v1/${this.modelUrl()}/${uuid}/unread-comments`, {});
    }
    public async countReadNotifications(): Promise<AxiosResponse<number>> {
        try {
            let response = await api.get(`v1/${this.modelUrl()}/read-notifications`, {});
            return response;
        } catch (error) {
            throw error;
        }
    }
    public async markRead(uuid: string) {
        return await api.put(`v1/${this.modelUrl()}/${uuid}/mark-as-read`);
    }
}